import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import Icon from '../../../Icon/Icon';
import theme from '../../../../../theme-config';

type Props = {
  isChosen?: boolean,
};

class Choice extends Component<Props> {
  render() {
    return (
      <View style={styles.container}>
        <View>{this.props.children && this.props.children(this.props.isChosen)}</View>
        <View style={[styles.circleContainer, this.props.isChosen && styles.isChosen]}>
          {this.props.isChosen && <Icon name="check" style={styles.icon} />}
        </View>
      </View>
    );
  }
}

const CIRCLE_DIAMETRE = 18;
const CIRCLE_BORDER_WIDTH = 1;

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    backgroundColor: theme.selectedBackground,
  },
  circleContainer: {
    position: 'absolute',
    marginLeft: 6,
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    height: CIRCLE_DIAMETRE,
    width: CIRCLE_DIAMETRE,
    borderRadius: CIRCLE_DIAMETRE / 2,
    borderColor: theme.secondaryColor,
    borderWidth: CIRCLE_BORDER_WIDTH,
  },
  icon: {
    color: theme.overPrimaryColor,
  },
  isChosen: {
    backgroundColor: theme.secondaryColor,
  },
});

export default Choice;
